import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import IsUndefinedNullOrEmpty from './valueCheck';
import moment from 'moment';

export const ValidateUser = (user, edit, allUser) => {
    var errorMsg = "";

    var strongRegex = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@$!%*?&]).{6,20}$");

    if (user.PhoneNumber === 0 || (user.PhoneNumber !== 0 && !/^[0-9]{10}$/.test(user.PhoneNumber.toString()))) {
        errorMsg = "Please enter valid Phone Number";
    }
    else if (parseInt(edit) === 0 && (IsUndefinedNullOrEmpty(user.Password.trim()) || user.Password.trim().length < 6)) {
        errorMsg = (user.Password.trim().length < 6) ? "Password should have minimum 6 characters." : "Password is a required field.";
    }
    else if (parseInt(edit) === 0 && !strongRegex.test(user.Password.trim())) {
        errorMsg = "Minimum Criteria for password does not match.";
    }
    else if (user.RoleID === "") {
        errorMsg = "Please enter valid Role";
    }
    else if (!IsUndefinedNullOrEmpty(user.UserName)) {
	if (user.UserName.trim().indexOf(' ') === -1) {
        var namedata = allUser.filter(c => c.UserName.trim().toLowerCase() === user.UserName.trim().toLowerCase());
        if (namedata.length > 0) {
            if (user._id === undefined) {
                errorMsg = "User Name Already Exist.";
            }
            if (namedata[0]._id !== user._id) {
                errorMsg = "User Name Already Exist.";
            }
        }
	}
        else {
            errorMsg = "Space not allowed in User Name.";
        }
    }

    if (errorMsg !== "") {
        Alert.error(errorMsg, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
        return false;
    }

    return true;
};

export const ValidateRole = (role, allRole) => {
    var errorMsg = "";
    if (!IsUndefinedNullOrEmpty(role.Name)) {
        var namedata = allRole.filter(c => c.Name.trim().toLowerCase() === role.Name.trim().toLowerCase());

        if (namedata.length > 0 && (IsUndefinedNullOrEmpty(role._id) || namedata[0]._id !== role._id)) {
            errorMsg = "Role Name Already Exist.";
        }
    }
    if (!IsUndefinedNullOrEmpty(role.Description) && role.Description.length > 200) {
        errorMsg = "Description cannot be more than 200 characters.";
    }
    if (!IsUndefinedNullOrEmpty(errorMsg)) {
        Alert.error(errorMsg, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
        return false;
    }

    return true;
};

export const ValidateQuotation = (Quote, IsInstant) => {
    let productErr = "";
    if (!IsInstant && IsUndefinedNullOrEmpty(Quote.CustomerID)) {
        productErr = "Please select Customer Survey Number";
    }
    else if (IsInstant && IsUndefinedNullOrEmpty(Quote.InstantCustomerName)) {
        productErr = "Please enter valid Customer Name";
    }
    else if (IsInstant && (Quote.InstantCustomerPhone <= 0 || !/^[0-9]{10}$/.test(Quote.InstantCustomerPhone.toString()))) {
        productErr = "Please enter valid Customer Phone";
    }
    else if (IsInstant && IsUndefinedNullOrEmpty(Quote.InstantCustomerEmail)) {
        productErr = "Please enter valid Customer Email";
    }
    else if (IsInstant && (Quote.InstantCustomerOriginFloor < 0 || Quote.InstantCustomerOriginFloor > 200)) {
        productErr = "Please enter valid Origin Floor";
    }
    else if (IsInstant && (Quote.InstantCustomerDestFloor < 0 || Quote.InstantCustomerDestFloor > 200)) {
        productErr = "Please enter valid Destination Floor";
    }
    else if (IsInstant && IsUndefinedNullOrEmpty(Quote.InstantCustomerOriginCity)) {
        productErr = "Please enter valid Customer Origin City";
    }
    else if (IsInstant && IsUndefinedNullOrEmpty(Quote.InstantCustomerDestCity)) {
        productErr = "Please enter valid Customer Dest. City";
    }
    else if (IsInstant && (Quote.InstantCustomerOriginPincode <= 0 || !/^[1-9][0-9]{5}$/.test(Quote.InstantCustomerOriginPincode.toString()))) {
        productErr = "Please enter valid Customer Origin Pincode";
    }
    else if (IsInstant && (Quote.InstantCustomerDestPincode <= 0 || !/^[1-9][0-9]{5}$/.test(Quote.InstantCustomerDestPincode.toString()))) {
        productErr = "Please enter valid Customer Dest. Pincode";
    }
    else if (IsInstant && Quote.InstantCustomerCFT < 0) {
        productErr = "Please enter valid CFT";
    }
    else if (Quote.TotalAmount <= 0) {
        productErr = "Quotation Amount cannot be Zero";
    }
    else if (IsUndefinedNullOrEmpty(Quote.Validity)) {
        productErr = "Please enter valid Quotation Validity";
    }

    if (!IsUndefinedNullOrEmpty(productErr)) {
        Alert.error(productErr, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });

        return false;
    }

    return true;
};

export const ValidateLicenseDetails = (License, SelectedOrg) => {
    var errorMsg = "";
    if (IsUndefinedNullOrEmpty(License.Date) || moment() > moment(License.Date)) {
        errorMsg = "Please enter valid License Date";
    }
    else if (IsUndefinedNullOrEmpty(SelectedOrg)) {
        errorMsg = "Refresh the page and try again.";
    }
    else if (IsUndefinedNullOrEmpty(SelectedOrg)) {
        errorMsg = "Refresh the page and try again.";
    }

    if (!IsUndefinedNullOrEmpty(errorMsg)) {
        Alert.error(errorMsg, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });

        return false;
    }

    return true;
};

export const validateOrgData = (organizationData) => {
    let enqErr = "";
    if (organizationData.PostalCode <= 0 || (organizationData.PostalCode !== 0 && !/^[1-9][0-9]{5}$/.test(organizationData.PostalCode.toString()))) {
        enqErr = "Please enter valid Postal code";
    }
    else if (IsUndefinedNullOrEmpty(organizationData.GSTNumber) || (organizationData.GSTNumber !== "" && !/^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[0-9]{1}Z[a-zA-Z0-9]{1}?$/.test(organizationData.GSTNumber.toString()))) {
        enqErr = "Please enter valid GST Number";
    }
    else if (organizationData.Contact <= 0 || (organizationData.Contact !== 0 && !/^[0-9]{10}$/.test(organizationData.Contact.toString()))) {
        enqErr = "Please enter valid Contact Number";
    }

    else if (organizationData.AlternateContact !== 0 && !/^[0-9]{10}$/.test(organizationData.AlternateContact.toString())) {
        enqErr = "Please enter valid Alt Contact Number";
    }
    else if (IsUndefinedNullOrEmpty(organizationData.PANNumber) || (!IsUndefinedNullOrEmpty(organizationData.PANNumber) &&
        !/([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/.test(organizationData.PANNumber.toString()))) {
        enqErr = "Please enter valid PAN Number";
    }
    else if (!IsUndefinedNullOrEmpty(organizationData.PANNumber) && !IsUndefinedNullOrEmpty(organizationData.GSTNumber) &&
        organizationData.GSTNumber.toUpperCase().indexOf(organizationData.PANNumber.toUpperCase()) === -1) {
        enqErr = "Please enter valid GST Number";
    }

    if (!IsUndefinedNullOrEmpty(enqErr)) {
        Alert.error(enqErr, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });

        return false;
    }

    return true;
};

export const ValidateExistingOrganization = (user, allOrganization) => {
    var errorMsg = "";
    if (!IsUndefinedNullOrEmpty(user.Name)) {
        var namedata = allOrganization.filter(c => c.Name.trim().toLowerCase() === user.Name.trim().toLowerCase());
        if (namedata.length > 0) {
            if (IsUndefinedNullOrEmpty(user._id) || namedata[0]._id !== user._id) {
                errorMsg = "Organization Name Already Exist.";
            }
        }
    }

    if (!IsUndefinedNullOrEmpty(errorMsg)) {
        Alert.error(errorMsg, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
        return false;
    }

    return true;
};

export const ValidateLeads = (SelectedServiceType, Internal) => {
    var errorMsg = "";
    if (SelectedServiceType === null || SelectedServiceType.value === null) {
        errorMsg = "Please enter valid Service Type";
    }
    else if (Internal.OriginOrg === "") {
        errorMsg = "Please enter valid Partner";
    }
    else if (Internal.CustName === "") {
        errorMsg = "Please enter valid Customer Name";
    }
    else if (Internal.CustContact !== 0 && !/^[0-9]{10}$/.test(Internal.CustContact.toString())) {
        errorMsg = "Please enter valid Phone Number";
    }
    else if (Internal.CustSource === "") {
        errorMsg = "Please enter valid Origin City";
    }
    else if (Internal.CustDest === "") {
        errorMsg = "Please enter valid Destination City";
    }
    else if (Internal.Remarks === "") {
        errorMsg = "Please enter valid Remarks";
    }

    if (errorMsg !== "") {
        Alert.error(errorMsg, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
        return false;
    }

    return true;
};

export const ValidateDlvr = (SelectedServiceType, Internal, AddressSearch) => {
    var errorMsg = "";
    if (SelectedServiceType === null || SelectedServiceType.value === null) {
        errorMsg = "Please enter valid Service Type";
    }
    else if (Internal.OriginCity.trim() === "") {
        errorMsg = "Please enter valid Origin City";
    }
    else if (Internal.OriginPinCode <= 0 || (Internal.OriginPinCode > 0 && !/^[1-9][0-9]{5}$/.test(Internal.OriginPinCode.toString()))) {
        errorMsg = "Please enter valid Origin PinCode";
    }
    else if (AddressSearch.Address.trim() === "") {
        errorMsg = "Please enter valid Destination Address";
    }
    else if (AddressSearch.City.trim() === "") {
        errorMsg = "Please enter valid Destination City";
    }
    else if (AddressSearch.State.trim() === "") {
        errorMsg = "Please enter valid Destination State";
    }
    else if (AddressSearch.Country.trim() === "") {
        errorMsg = "Please enter valid Destination Country";
    }
    else if (AddressSearch.PinCode <= 0 || (AddressSearch.PinCode > 0 && !/^[1-9][0-9]{5}$/.test(AddressSearch.PinCode.toString()))) {
        errorMsg = "Please enter valid Destination PinCode";
    }
    else if (Internal.DestContact <= 0 || (Internal.DestContact > 0 && !/^[0-9]{10}$/.test(Internal.DestContact.toString()))) {
        errorMsg = "Please enter valid Destination Contact";
    }
    else if (Internal.DestOrg === "") {
        errorMsg = "Please enter valid Destination Partner";
    }
    else if (Internal.TotalCFT <= 0) {
        errorMsg = "Please enter valid CFT";
    }
    else if (Internal.DestCustomerName.trim() === "") {
        errorMsg = "Please enter valid Customer Name";
    }
    else if (Internal.TruckNumber.trim() === "") {
        errorMsg = "Please enter valid Truck Number";
    }
    else if (Internal.TrackingLink.trim() === "") {
        errorMsg = "Please enter valid Tracking Link";
    }
    else if (Internal.DriverContact <= 0 || (Internal.DriverContact > 0 && !/^[0-9]{10}$/.test(Internal.DriverContact.toString()))) {
        errorMsg = "Please enter valid Driver Contact";
    }
    else if (Internal.Remarks === "") {
        errorMsg = "Please enter valid Remarks";
    }

    if (errorMsg !== "") {
        Alert.error(errorMsg, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
        return false;
    }

    return true;
};

export const ValidateQuotes = (SelectedServiceType, Internal) => {
    var errorMsg = "";
    if (SelectedServiceType === null || SelectedServiceType.value === null) {
        errorMsg = "Please enter valid Service Type";
    }
    else if (Internal.OriginOrg === "") {
        errorMsg = "Please enter valid Partner";
    }
    else if (Internal.CustSource === "") {
        errorMsg = "Please enter valid Origin City";
    }
    else if (Internal.CustDest === "") {
        errorMsg = "Please enter valid Destination City";
    }
    else if (Internal.TotalCFT <= 0) {
        errorMsg = "Please enter valid CFT";
    }
    else if (Internal.Remarks === "") {
        errorMsg = "Please enter valid Remarks";
    }

    if (errorMsg !== "") {
        Alert.error(errorMsg, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
        return false;
    }

    return true;
};


export const ValidateTrackLimit = (TrackLimit, isEdit) => {
    var errorMsg = "";
    if (TrackLimit.OrgID === "") {
        errorMsg = "Please enter valid Partner";
    }
    else if (TrackLimit.InitialLimit === 0) {
        errorMsg = "Please enter Limit";
    }
    else if (isEdit === 1 && TrackLimit.AddedLimit === 0) {
        errorMsg = "Please enter New Limit";
    }
    if (errorMsg !== "") {
        Alert.error(errorMsg, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
        return false;
    }

    return true;
};

export const ValidateEventRecord = (eventDetails, allEvents) => {
    var errorMsg = "";
    if (eventDetails.Name === "") {
        errorMsg = "Please enter valid Name";
    }
    else if (eventDetails.Heading === "") {
        errorMsg = "Please enter valid Heading";
    }
    else if (eventDetails.Location === "") {
        errorMsg = "Please enter valid Location";
    }
    else if (eventDetails.StartDate === null) {
        errorMsg = "Please enter valid Start Date";
    }
    else if (eventDetails.EndDate === null) {
        errorMsg = "Please enter valid End Date";
    }
    else if (moment(eventDetails.StartDate) < moment()) {
        errorMsg = "Enter valid Start Date";
    }
    else if (moment(eventDetails.EndDate) < moment()) {
        errorMsg = "Enter valid End Date";
    }
    else if (moment(eventDetails.StartDate) > moment(eventDetails.EndDate)) {
        errorMsg = "Start must be less than End Date";
    }
    if (!IsUndefinedNullOrEmpty(eventDetails.Name)) {
        var namedata = allEvents.filter(c => c.Name.trim().toLowerCase() === eventDetails.Name.trim().toLowerCase());
        if (namedata.length > 0) {
            if (IsUndefinedNullOrEmpty(eventDetails._id) || namedata[0]._id !== eventDetails._id) {
                errorMsg = "Event Name Already Exist.";
            }
        }
    }
    if (errorMsg !== "") {
        Alert.error(errorMsg, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
        return false;
    }

    return true;
};

export const ValidateEventRegistration = (eventDetails) => {
    var errorMsg = "";
    if (eventDetails.PartnerID === "" || eventDetails.PartnerID.length < 24) {
        errorMsg = "Please enter valid Member ID";
    }
    if (errorMsg !== "") {
        Alert.error(errorMsg, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
        return false;
    }

    return true;
};

export const LicenseExpiryMessage = (data) => {
    for (var i = 0; i < data.length; i++) {
        let ExpiryDate = !IsUndefinedNullOrEmpty(data[i].ExpiryDate) ? moment(data[i].ExpiryDate) : null;
        if (ExpiryDate) {
            let FifteenDaysExpiry = moment().add(15, 'days').endOf('day');
            let OneMonthDaysExpiry = moment().add(30, 'days').endOf('day');
            var diffInDays = null;
            if (FifteenDaysExpiry >= ExpiryDate) {
                diffInDays = ExpiryDate.diff(moment(), 'days');
                data[i].ExpiryTimer = {
                    Color: "red", days: (diffInDays > 0 ? (diffInDays.toString() + " days left") :
                        ("License Expired " + Math.abs(diffInDays) + " days ago"))
                };
            }
            else if (OneMonthDaysExpiry >= ExpiryDate) {
                diffInDays = ExpiryDate.diff(moment(), 'days');
                data[i].ExpiryTimer = {
                    Color: "orange",
                    days: (diffInDays > 0 ? (diffInDays.toString() + " days left") :
                        ("License Expired " + Math.abs(diffInDays) + " days ago"))
                };
            }
            else {
                diffInDays = ExpiryDate.diff(moment(), 'days');
                var daysLeftMessage = "";
                if (diffInDays < 0) {
                    daysLeftMessage = "License Expired " + Math.abs(diffInDays) + " days ago";
                    data[i].ExpiryTimer = { Color: "red", days: daysLeftMessage };
                }
                else {
                    daysLeftMessage = diffInDays.toString() + " days left";
                    data[i].ExpiryTimer = { Color: "green", days: daysLeftMessage };
                }
            }
        }
    }

    return data;
};

export const GreetingMessage = () => {
    var currentHour = moment().format("HH");

    if (currentHour >= 3 && currentHour < 12) {
        return "Good Morning";
    }
    else if (currentHour >= 12 && currentHour < 15) {
        return "Good Afternoon";
    }
    else if (currentHour >= 15 && currentHour < 20) {
        return "Good Evening";
    }
    else {
        return "Good Evening";
    }
};

export const CallBackAlert = (data) => {
    if (data.success) {
        Alert.success(data.message, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
    }
    else {
        Alert.error(data.message, {
            position: 'bottom-right',
            effect: 'slide',
            html: false
        });
    }
};

export const PreLoadAddress = (places) => {
    var data = places?.address_components;
    var Address = "";
    var Country = "";
    var PostalCode = "";
    var City = "";
    var State = "";

    data.forEach(place => {
        const componentType = place.types[0];
        switch (componentType) {
            case "street_number":
                Address += `${place.long_name},`;
                break;
            case "route":
                Address += `${place.long_name},`;
                break;

            case "sublocality_level_3":
                Address += `${place.long_name},`;
                break;

            case "sublocality_level_2":
                Address += `${place.long_name},`;
                break;

            case "sublocality_level_1":
                Address += `${place.long_name},`;
                break;

            case "postal_code":
                PostalCode = place.long_name;
                break;

            case "locality":
                City = place.long_name;
                break;
            case "administrative_area_level_1":
                State = place.long_name;
                break;

            case "country":
                Country = place.long_name;
                break;
            default: break;
        }
    });

    return {
        Address, City,
        State, Country, PostalCode
    };

}
